import { LoadAllProductsUsecase, LoadAllProductsUsecaseImp } from 'domain/usecases/load-all-products-usecase';
import { makeHttpLoadAllProductsRepository } from '../repositories/http/product-http-repository-factory';

export const makeLoadAllProductsUsecase = (): LoadAllProductsUsecase => {
  return new LoadAllProductsUsecaseImp(makeHttpLoadAllProductsRepository());
};
